import PropTypes from "prop-types";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

// Create the Portal DIV for drag and drop
const portal = document.createElement("div");
portal.setAttribute("id", "ql-portal");
if (!document.body) {
  throw new Error("body not ready for portal creation!");
}
document.body.appendChild(portal);

// Styling
const SimpleQuickListItem = styled.div`
  padding: var(--padding-5px);
  margin-bottom: var(--margin-5px);
  background-color: var(--dnd-item-bg-color);
  border: 1px solid var(--dnd-item-border);
  position: relative;
  overflow: hidden;
  height: 28px;
  font-size: 14px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

class QuickListItem extends Component {
  render() {
    const { provided, snapshot, item } = this.props;
    if (!item) return null;

    const usePortal = snapshot.isDragging;

    // Need to check as this component is reused for columns in quick list edit
    const isQuicklist = Object.keys(item).includes("quickListCode");

    const child = (
      <SimpleQuickListItem
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        $inPortal={usePortal}
        $isEditable={isQuicklist ? item.isEditable : true}
      >
        {item.name}
      </SimpleQuickListItem>
    );

    if (!usePortal) {
      return child;
    }

    // if dragging - put the item in a portal
    return ReactDOM.createPortal(child, document.getElementById("ql-portal"));
  }
}

QuickListItem.propTypes = {
  provided: PropTypes.object.isRequired,
  snapshot: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
};
export default QuickListItem;